import React from 'react';
import { BackgroundThemeRevision, ColorId } from 'referral-types';
import { useTheme } from '../../../../../context/theme/useTheme';
import { getCssVariableForColorId } from '../../../../../constants';

/*

Waving Transition - Layered wave patterns with opacity variations
Takes 2 color inputs: user-selectable c1 and c2

Original colors: #115500, #227700

*/

const WavingTransitionBackground: React.FC<{ themeRevision?: Partial<BackgroundThemeRevision> }> = (props) => {
  const { colorId1, colorId2 } = props.themeRevision || {};
  const { isDarkMode } = useTheme();
  const colorStyles1 = getCssVariableForColorId(colorId1 || ColorId.Primary1, isDarkMode);
  const colorStyles2 = getCssVariableForColorId(colorId2 || ColorId.Primary4, isDarkMode);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        backgroundColor: `rgb(var(${colorStyles1}, 255 255 255))`,
        pointerEvents: 'none',
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1920 1080"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
        preserveAspectRatio="xMidYMid slice"
      >
        <g fill={`rgb(var(${colorStyles2}, 0 0 0))`}>
          <path
            d="M887.4 1200.1S727 1123.7 667.8 1043c-49-66.8-78.6-133.8-167-151.7-45.8-9.3-93.2-7.2-139.6-13-88-11-177.8-57-214-138-17-38.2-20.8-81-34.9-120.3C78.8 526-42.8 500-132.6 502.2v715l1020-17z"
            fillOpacity=".5"
          />
          <path
            d="M-111 758.2C0 685.2 4.6 619 223 618c76-.3 162.3 48.9 198 91.3 75.5 89.9 135.7 141.7 256.5 162 89.2 15 180.2-1.4 270-12.1 133-15.9 259.5-9.5 375.8 63a1429.6 1429.6 0 0 0 509.4 194.4l-1943.7 8.5V758.2z"
            fillOpacity=".5"
          />
          <path
            d="M2092.9 703c-77.7-13.7-154.5-1.2-227 28-64.2 25.7-107.3 84-171 109.4-57.2 22.6-122 11-180.6-7.5-141-44.6-318.8-151.2-462.4-56.6-77 50.8-111.1 149.7-187.1 202-52.2 35.9-117.8 45.4-181 50.4-148 11.7-192.3 134.8-192.3 134.8l1601.4-8.7V703z"
            fillOpacity=".5"
          />
          <path
            d="M1202.7 1090s33.8-111.3 141.8-159.1c86.2-38.1 190.6-62.3 244.5-128 52.6-64.2 32.3-159.2 102.1-212 33-25 79.5-34.6 124.5-39.5 66.8-7.5 135-6.7 201.6 2.1V1090h-814.5z"
            fillOpacity=".5"
          />
          <path d="M-23 969.3c212.2 4.4 432 70.5 645.8 48.8 79.6-8 159.5-28.4 238.7-16.8 55.3 8.2 106.8 33.4 161.3 45.8 298.2 67.9 508.4-43.4 752.2-64.1 350.8-29.8 898 181 898 181l-2694-11.7-2-183z" />
        </g>
      </svg>
    </div>
  );
};

export default WavingTransitionBackground;
